import { apiHelper } from '@/utils';
import { API } from '@/constants';

export const candidateStatusService = {
    getAll,
    store,
    show,
    update,
    updateSequence,
    updateStatus,
    softDelete,
    destroy,
};

const MODULE = {
    CANDIDATE_STATUS: 'candidate-statuses',
};

const API_URL = API.BASE_URL_API + '/v1';

export function getAll (filter) {
    const request = {
        params: {
            show_na: filter?.showNa,
            is_active: filter?.isActive,
            page: filter?.pageNumber,
            size: filter?.pageSize,
        },
    };

    let array = filter?.searchArray;
    array?.forEach((word, index) => {
        if (word != null || word != '') {
            var searchParam = `search_words[${index}]`;
            request.params[searchParam] = word;
        }
    });

    return apiHelper(API_URL).get(`/${MODULE.CANDIDATE_STATUS}`, request);
}

export function store (data) {
    const request = {
        name: data.name,
        description: data.description,
        email_subject: data.emailSubject,
        email_content: data.emailContent,
        email_cc: (data.emailCc ?? []).filter(item => item),
        is_email: data.isEmail,
        is_initial: data.isInitial,
        is_create_user: data.isCreateUser,
    };

    return apiHelper(API_URL).post(`/${MODULE.CANDIDATE_STATUS}`, request);
}

export function show (uuid) {
    return apiHelper(API_URL).get(`/${MODULE.CANDIDATE_STATUS}/${uuid}`);
}

export function update (data) {
    const request = {
        name: data.name,
        description: data.description,
        email_subject: data.emailSubject,
        email_content: data.emailContent,
        email_cc: (data.emailCc ?? []).filter(item => item),
        is_email: data.isEmail,
        is_initial: data.isInitial,
        is_create_user: data.isCreateUser,
    };

    return apiHelper(API_URL).put(`/${MODULE.CANDIDATE_STATUS}/${data.uuid}`, request);
}

export function updateSequence (data) {
    const request = {
        uuids: data.uuids || [],
    };

    return apiHelper(API_URL).patch(`/${MODULE.CANDIDATE_STATUS}/sequence`, request);
}

export function updateStatus (data) {
    const request = {
        is_active: data.isActive,
    };

    return apiHelper(API_URL).patch(`/${MODULE.CANDIDATE_STATUS}/status/${data.uuid}`, request);
}

export function softDelete (data) {
    return apiHelper(API_URL).patch(`/${MODULE.CANDIDATE_STATUS}/delete/${data.uuid}`);
}

export function destroy (data) {
    return apiHelper(API_URL).delete(`/${MODULE.CANDIDATE_STATUS}/${data.uuid}`);
}

